module.exports = __webpack_public_path__ + "static/media/21.9eb35b97.jpg";